import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

interface Rating {
  value: number;
  submitted: boolean;
}

const sessionRatingAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<Rating>(`rating-${sessionId}`, {
    value: 0,
    submitted: false,
  })
);

export const ratingAtom = createDerivedSessionAtom<Rating>(sessionRatingAtom);
